import React, { useEffect, useState } from "react";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";

const toast = (m, t = "success") => {
  toastr.options = {
    closeButton: true,
    progressBar: true,
    timeOut: 3000,
  };

  toastr[t](m);
};

const blankRegister = {
  name: "",
  email: "",
  mobile: "",
};

export default function TopayOnboarding() {

  const [loading, setLoading] = useState(false);

  // =====================================
  // STATES
  // =====================================

  const [merchantList, setMerchantList] = useState([]);

  const [selectedMerchant, setSelectedMerchant] = useState(null);

  const [walletBalance, setWalletBalance] = useState([]);

  const [transactions, setTransactions] = useState([]);

  const [registerForm, setRegisterForm] = useState(blankRegister);

  const [otpForm, setOtpForm] = useState({
    otp: "",
    maritalStatus: "",
    employmentIndustry: "",
    employmentType: "",
    accountno: "",
    bankName: "",
    branchName: "",
    ifscCode: "",
  });

  const maritalStatuses = [
    "SINGLE",
    "MARRIED",
  ];

  const employmentIndustries = [
    "AGRICULTURE_FOOD_NATURAL_RESOURCES",
    "ARCHITECTURE_AND_CONSTRUCTION",
    "ARTS_AUDIO_OR_VIDEO_TECHNOLOGY_AND_COMMUNICATIONS",
    "BUSINESS_MANAGEMENT_AND_ADMINISTRATION",
    "EDUCATION_AND_TRAINING",
    "FINANCE",
    "GOVERNMENT_AND_PUBLIC_ADMINISTRATION",
    "HEALTH_SCIENCE",
    "HOSPITALITY_AND_TOURISM",
    "HUMAN_SERVICES",
    "INFORMATION_TECHNOLOGY",
    "LAW_PUBLIC_SAFETY_CORRECTIONS_AND_SECURITY",
    "MANUFACTURING",
    "MARKETING_SALES_AND_SERVICE",
    "SCIENCE_TECHNOLOGY_ENGINEERING_AND_MATHEMATICS",
    "TRANSPORTATION_DISTRIBUTION_AND_LOGISTICS",
  ];

  const employmentTypes = [
    "EMPLOYED",
    "UNEMPLOYED",
    "ENTREPRENEUR",
    "PUBLIC_SECTOR_EMPLOYEE",
    "FREELANCER",
    "HOUSEWORK",
    "APPRENTICE",
    "RETIRED",
    "STUDENT",
    "SELF_EMPLOYED",
    "MILITARY_OR_COMMUNITY_SERVICE",
  ];

  const [panImage, setPanImage] = useState("");

  const [vcipData, setVcipData] = useState(null);

  const [walletDebitForm, setWalletDebitForm] = useState({
    amount: "",
    description: "",
  });

  const [walletDebitLoading, setWalletDebitLoading] = useState(false);
  const [walletTopupForm, setWalletTopupForm] = useState({
    amount: "",
  });
  const [walletTopupLoading, setWalletTopupLoading] =
  useState(false);

  const [walletPasswordForm, setWalletPasswordForm] =
  useState({
    credential: "",
  });

  const [walletPasswordLoading, setWalletPasswordLoading] =
  useState(false);

  const [forgetWalletLoading, setForgetWalletLoading] =
  useState(false);

  const [resetWalletForm, setResetWalletForm] =
  useState({
    otpCode: "",
    credential: "",
  });

  const [resetWalletLoading, setResetWalletLoading] =
  useState(false);

  const [cardList, setCardList] = useState([]);

  const [cardLoading, setCardLoading] =
  useState(false);

  const [cardDetails, setCardDetails] = useState(null);

  const [cardDetailsLoading, setCardDetailsLoading] =
  useState(false);

  const [cardActionForm, setCardActionForm] = useState({
    kitNo: "",
    flag: "L",
    reason: "",
  });

  const [cardActionLoading, setCardActionLoading] =
  useState(false);

  const cardActionFlags = [
    {
      label: "Lock",
      value: "L",
    },
    {
      label: "Unlock",
      value: "UL",
    },
    {
      label: "Block",
      value: "BL",
    },
  ];

  const [physicalCardLoading, setPhysicalCardLoading] =
  useState(false);

  const [cardPreference, setCardPreference] = useState(null);

  const [preferenceLoading, setPreferenceLoading] =
    useState(false);

  const [merchantProfileForm, setMerchantProfileForm] =
  useState({
    legalName: "",
    mccCode: "",
    merchantType: "",
    merchantGenre: "",
    brandName: "",
    ownershipType: "",
  });

  const [merchantProfileLoading, setMerchantProfileLoading] =
  useState(false);

  

  // =====================================
  // MODAL HELPERS
  // =====================================

  const openModal = (id) => {
    const el = document.getElementById(id);
    new window.bootstrap.Modal(el).show();
  };

  const closeModal = (id) => {
    const modal = window.bootstrap.Modal.getInstance(
      document.getElementById(id)
    );

    if (modal) {
      modal.hide();
    }
  };

  const getIP = async () => {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      console.log("IP Address:", data.ip);
      return data.ip;
      
    } catch {
      return "0.0.0.0";
    }
  };

  const getGeoCode = () => {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        return resolve("0,0");
      }

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lng = pos.coords.longitude;
          resolve(`${lat},${lng}`);
        },
        () => resolve("0,0") // fallback
      );
    });
  };

  

  // =====================================
  // COMMON API
  // =====================================

  const postApi = async (url, payload) => {

    const res = await authFetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message || "Request Failed");
    }

    return data;
  };

  // =====================================
  // LOAD LIST
  // =====================================

  const loadMerchants = async () => {

    try {

      const res = await authFetch(
        "/api/v1/member/topay/userlist"
      );

      const data = await res.json();

      setMerchantList(Array.isArray(data) ? data : []);

    } catch (err) {

      console.log(err);
    }
  };

  // =====================================
  // REGISTER MERCHANT
  // =====================================

  const handleRegisterMerchant = async () => {

    try {

      if (!registerForm.name) {
        return toast("Enter Name", "warning");
      }

      if (!registerForm.mobile) {
        return toast("Enter Mobile", "warning");
      }

      setLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/onboard",
        registerForm
      );

      toast("Merchant Registered");

      closeModal("registerMerchantModal");

      setSelectedMerchant({
        merchantId: data.merchantId,
        status: data.status,
        name: registerForm.name,
        mobile: registerForm.mobile,
        email: registerForm.email,
      });

      loadMerchants();

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  // =====================================
  // VERIFY OTP
  // =====================================

  const handleVerifyOtp = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      const ip = await getIP();
      const geoCode = await getGeoCode();

      setLoading(true);

      const payload = {
        merchantId: selectedMerchant.merchantId,

        otp: otpForm.otp,

        maritalStatus: otpForm.maritalStatus,

        employmentIndustry: otpForm.employmentIndustry,

        employmentType: otpForm.employmentType,

        ipAddress: ip,

        accountno: otpForm.accountno,

        bankName: otpForm.bankName,

        branchName: otpForm.branchName,

        ifscCode: otpForm.ifscCode,

        termconditionAcceptflag: true,

        userconsentflag: true,

        deviceInfo: {
          deviceId: crypto.randomUUID(),

          deviceType: "DESKTOP",

          os: navigator.platform || "WINDOWS",

          appVersion: "1.0.0",

          telecom: navigator.connection?.effectiveType || "Unknown",

          geoCode,

          appId: "com.suvidhape.web",

          ipAddress: ip,

          location: "India",

          mobile: selectedMerchant.mobile,
        },
      };

      const data = await postApi(
        "/api/v1/member/topay/verify-otp",
        payload
      );

      toast("OTP Verified");

      setSelectedMerchant((prev) => ({
        ...prev,
        status: data.status,
      }));

      closeModal("otpModal");

      loadMerchants();

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  // =====================================
  // CONVERT BASE64
  // =====================================

  const convertToBase64 = (file) => {

    return new Promise((resolve, reject) => {

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result.split(",")[1]);
      };

      reader.onerror = reject;
    });
  };

  // =====================================
  // PAN UPLOAD
  // =====================================

  const handlePanUpload = async (e) => {

    try {

      const file = e.target.files[0];

      if (!file) return;

      const base64 = await convertToBase64(file);

      setPanImage(base64);

      toast("PAN Uploaded");

    } catch (err) {

      toast("Upload Failed", "error");
    }
  };

  // =====================================
  // PAN OCR
  // =====================================

  const handlePanOcr = async () => {

    try {

      setLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/pan-ocr",
        {
          merchantId: selectedMerchant.merchantId,
          ocrimage: panImage,
        }
      );

      toast("PAN OCR Success");

      setSelectedMerchant((prev) => ({
        ...prev,
        status: data.status,
      }));

      closeModal("panModal");

      loadMerchants();

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  // =====================================
  // START VCIP
  // =====================================

  const handleStartVcip = async () => {

    try {

      setLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/start-vcip",
        {
          merchantId: selectedMerchant.merchantId,
        }
      );

      setVcipData(data.data);

      toast("VCIP Started");

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  // =====================================
  // CHECK VCIP STATUS
  // =====================================

  const handleCheckVcip = async () => {

    try {

      setLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/vcip-status",
        {
          merchantId: selectedMerchant.merchantId,
        }
      );

      if (data.data?.state === "Success") {

        toast("VCIP Completed");

        setSelectedMerchant((prev) => ({
          ...prev,
          status: "ACTIVE",
        }));

        closeModal("vcipModal");

        getWalletBalance();

      } else {

        toast(data.data?.state || "Pending", "warning");
      }

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setLoading(false);
    }
  };

  // =====================================
  // WALLET BALANCE
  // =====================================

  const getWalletBalance = async () => {

    try {

      const data = await postApi(
        "/api/v1/member/topay/wallet-balance",
        {
          merchantId: selectedMerchant.merchantId,
        }
      );

      setWalletBalance(data?.data?.wallets || []);

    } catch (err) {

      console.log(err);
    }
  };

  // =====================================
  // TRANSACTIONS
  // =====================================

  const getTransactions = async () => {

    try {

      const data = await postApi(
        "/api/v1/member/topay/wallet-transactions",
        {
          merchantId: selectedMerchant.merchantId,
          pageNo: 0,
          pageSize: 10,
        }
      );

      setTransactions(data?.data?.transactions || []);

    } catch (err) {

      console.log(err);
    }
  };

  // =====================================
  // SELECT MERCHANT
  // =====================================

  const handleSelectMerchant = (merchant) => {

    setSelectedMerchant(merchant);

    if (merchant.status === "ACTIVE") {
      getWalletBalance();
      getTransactions();
    }
  };

  // =====================================
  // WALLET DEBIT
  // =====================================

  const handleWalletDebit = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      if (!walletDebitForm.amount) {
        return toast("Enter Amount", "warning");
      }

      if (!walletDebitForm.description) {
        return toast("Enter Description", "warning");
      }

      setWalletDebitLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/wallet-debit",
        {
          merchantId: selectedMerchant.merchantId,
          amount: walletDebitForm.amount,
          description: walletDebitForm.description,
        }
      );

      toast(data.message || "Wallet Debit Success");

      closeModal("walletDebitModal");

      setWalletDebitForm({
        amount: "",
        description: "",
      });

      getWalletBalance();
      getTransactions();

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setWalletDebitLoading(false);
    }
  };

  // =====================================
  // WALLET TOPUP
  // =====================================

  const handleWalletTopup = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      if (!walletTopupForm.amount) {
        return toast("Enter Amount", "warning");
      }

      setWalletTopupLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/wallet-topup",
        {
          merchantId: selectedMerchant.merchantId,
          amount: walletTopupForm.amount,
        }
      );

      toast(data.message || "Wallet Topup Success");

      closeModal("walletTopupModal");

      setWalletTopupForm({
        amount: "",
      });

      getWalletBalance();
      getTransactions();

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setWalletTopupLoading(false);
    }
  };

  // =====================================
  // VALIDATE WALLET PASSWORD
  // =====================================

  const handleValidateWalletPassword = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      if (!walletPasswordForm.credential) {
        return toast(
          "Enter Wallet Password",
          "warning"
        );
      }

      setWalletPasswordLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/validate-wallet-password",
        {
          merchantId: selectedMerchant.merchantId,
          credential: walletPasswordForm.credential,
        }
      );

      toast(
        data.message ||
        "Wallet Password Validated"
      );

      closeModal("walletPasswordModal");

      setWalletPasswordForm({
        credential: "",
      });

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setWalletPasswordLoading(false);
    }
  };

  // =====================================
  // FORGET WALLET PASSWORD
  // =====================================

  const handleForgetWalletPassword = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      setForgetWalletLoading(true);

      const ip = await getIP();

      const geoCode = await getGeoCode();

      const payload = {
        merchantId: selectedMerchant.merchantId,

        deviceInfo: {
          deviceId: crypto.randomUUID(),

          deviceType: "DESKTOP",

          os: navigator.platform || "WINDOWS",

          appVersion: "1.0.0",

          telecom:
            navigator.connection?.effectiveType ||
            "Unknown",

          geoCode,

          appId: "com.suvidhape.web",

          ipAddress: ip,

          location: "India",

          mobile: selectedMerchant.mobile,
        },
      };

      const data = await postApi(
        "/api/v1/member/topay/forget-wallet-password",
        payload
      );

      toast(
        data.message ||
        "Forget Wallet Password Request Sent"
      );

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setForgetWalletLoading(false);
    }
  };

  // =====================================
  // RESET WALLET PASSWORD
  // =====================================

  const handleResetWalletPassword = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      if (!resetWalletForm.otpCode) {
        return toast("Enter OTP", "warning");
      }

      if (!resetWalletForm.credential) {
        return toast(
          "Enter New Wallet Password",
          "warning"
        );
      }

      setResetWalletLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/reset-wallet-password",
        {
          merchantId: selectedMerchant.merchantId,

          otpCode: resetWalletForm.otpCode,

          credential:
            resetWalletForm.credential,
        }
      );

      toast(
        data.message ||
        "Wallet Password Reset Success"
      );

      closeModal("resetWalletModal");

      setResetWalletForm({
        otpCode: "",
        credential: "",
      });

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setResetWalletLoading(false);
    }
  };

  // =====================================
  // CARD LIST
  // =====================================

  const getCardList = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      setCardLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/card-list",
        {
          merchantId: selectedMerchant.merchantId,
        }
      );

      setCardList(data?.data || null);

      openModal("cardListModal");
      // toast("Card List Loaded");

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setCardLoading(false);
    }
  };

  // =====================================
  // CARD DETAILS
  // =====================================

  const getCardDetails = async (kitNo) => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      setCardDetailsLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/card-details",
        {
          merchantId: selectedMerchant.merchantId,
          kitNo: kitNo,
        }
      );

      // setCardDetails(data?.data || null);

      // // openModal("cardDetailsModal");
      // document.getElementById("cardDetailsModal")

      const url = data?.data?.result;

      if (url) {

        window.open(url, "_blank");

        toast("Opening Card Details");

      } else {

        toast("Card URL Not Found", "warning");
      }
    } catch (err) {

      toast(err.message, "error");

    } finally {

      setCardDetailsLoading(false);
    }
  };

  // =====================================
  // CARD ACTION
  // =====================================

  const handleCardAction = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      if (!cardActionForm.kitNo) {
        return toast("Kit Number Missing", "warning");
      }

      if (!cardActionForm.reason) {
        return toast("Enter Reason", "warning");
      }

      setCardActionLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/card-action",
        {
          merchantId: selectedMerchant.merchantId,
          kitNo: cardActionForm.kitNo,
          flag: cardActionForm.flag,
          reason: cardActionForm.reason,
        }
      );

      toast(data.message || "Card Action Success");

      closeModal("cardActionModal");

      setCardActionForm({
        kitNo: "",
        flag: "L",
        reason: "",
      });

      getCardList();

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setCardActionLoading(false);
    }
  };

  // =====================================
  // REQUEST PHYSICAL CARD
  // =====================================

  const requestPhysicalCard = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      setPhysicalCardLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/request-physical-card",
        {
          merchantId: selectedMerchant.merchantId,
        }
      );

      toast(
        data.message ||
        "Physical Card Request Submitted"
      );

      getCardList();

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setPhysicalCardLoading(false);
    }
  };

  // =====================================
  // fetch Card Preference 
  // =====================================

  const fetchCardPreference = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      setPreferenceLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/fetch-card-preference",
        {
          merchantId: selectedMerchant.merchantId,
        }
      );

      setCardPreference(data?.data || null);

      openModal("cardPreferenceModal");

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setPreferenceLoading(false);
    }
  };

  // =====================================
  // set Card Preference 
  // =====================================

  const [savePreferenceLoading, setSavePreferenceLoading] =
  useState(false);

  const setCardPreferenceApi = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      setSavePreferenceLoading(true);

      const payload = {
        merchantId: selectedMerchant.merchantId,

        atm: cardPreference?.atm || false,

        contactless:
          cardPreference?.contactless || false,

        dcc: cardPreference?.dcc || false,

        ecom: cardPreference?.ecom || false,

        international:
          cardPreference?.international || false,

        pos: cardPreference?.pos || false,
      };

      const data = await postApi(
        "/api/v1/member/topay/set-card-preference",
        payload
      );

      toast(
        data.message ||
        "Card Preference Updated"
      );

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setSavePreferenceLoading(false);
    }
  };


  // =====================================
  // register Merchant Profile 
  // =====================================

  const registerMerchantProfile = async () => {

    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      const ip = await getIP();

      const geoCode = await getGeoCode();

      setMerchantProfileLoading(true);

      const payload = {

        merchantId: selectedMerchant.merchantId,

        legalName:
          merchantProfileForm.legalName,

        mccCode:
          merchantProfileForm.mccCode,

        merchantType:
          merchantProfileForm.merchantType,

        merchantGenre:
          merchantProfileForm.merchantGenre,

        brandName:
          merchantProfileForm.brandName,

        ownershipType:
          merchantProfileForm.ownershipType,

        deviceInfo: {

          deviceId: crypto.randomUUID(),

          deviceType: "DESKTOP",

          os: navigator.platform || "WINDOWS",

          appVersion: "1.0.0",

          telecom:
            navigator.connection?.effectiveType ||
            "Unknown",

          geoCode,

          appId: "com.suvidhape.web",

          ipAddress: ip,

          location: "India",

          mobile: selectedMerchant.mobile,
        },
      };

      const data = await postApi(
        "/api/v1/member/topay/register-merchant-profile",
        payload
      );

      toast(
        data.message ||
        "Merchant Profile Registered"
      );

      closeModal("merchantProfileModal");

      loadMerchants();

    } catch (err) {

      toast(err.message, "error");

    } finally {

      setMerchantProfileLoading(false);
    }
  };

  // =====================================
  // INIT
  // =====================================

  useEffect(() => {
    loadMerchants();
  }, []);

  return (
    <>

      <div className="page-wrapper">
        <div className="page-content-wrapper">
          <div className="page-content">

            <div className="card">
              <div className="card-body">

                {/* HEADER */}

                <div className="d-flex justify-content-between align-items-center mb-3">

                  <h4 className="mb-0">
                    Topay Onboarding Dashboard
                  </h4>

                  <button
                    className="btn btn-primary"
                    onClick={() => openModal("registerMerchantModal")}
                  >
                    ADD
                  </button>

                </div>

                <hr />

                {/* SELECTED MERCHANT */}

                {selectedMerchant && (

                  <div className="card mb-4 border">
                    <div className="card-body">

                      <div className="row">

                        <div className="col-md-3">
                          <strong>Merchant ID</strong>
                          <div>{selectedMerchant.merchantId}</div>
                        </div>

                        <div className="col-md-3">
                          <strong>Name</strong>
                          <div>{selectedMerchant.name}</div>
                        </div>

                        <div className="col-md-3">
                          <strong>Mobile</strong>
                          <div>{selectedMerchant.mobile}</div>
                        </div>

                        <div className="col-md-3">
                          <strong>Status</strong>
                          <div>
                            <span className="badge bg-primary">
                              {selectedMerchant.status}
                            </span>
                          </div>
                        </div>

                      </div>

                      <hr />

                      {/* ACTIONS */}

                      <div className="d-flex gap-2 flex-wrap">

                        <button
                          className="btn btn-warning"
                          onClick={() => openModal("otpModal")}
                        >
                          Verify OTP
                        </button>

                        <button
                          className="btn btn-info"
                          onClick={() => openModal("panModal")}
                        >
                          PAN OCR
                        </button>

                        <button
                          className="btn btn-dark"
                          onClick={() => openModal("vcipModal")}
                        >
                          VCIP
                        </button>

                        <button
                          className="btn btn-success"
                          onClick={() => {
                            getWalletBalance();
                            getTransactions();
                          }}
                        >
                          Refresh Wallet
                        </button>

                        <button
                          className="btn btn-danger ms-2"
                          onClick={() => openModal("walletDebitModal")}
                        >
                          Wallet Debit
                        </button>
                        <button
                          className="btn btn-success"
                          onClick={() => openModal("walletTopupModal")}
                        >
                          Wallet Topup
                        </button>
                        <button
                          className="btn btn-dark ms-2"
                          onClick={() => openModal("walletPasswordModal")}
                        >
                          Wallet Pin
                        </button>

                        <button
                          className="btn btn-warning ms-2"
                          onClick={handleForgetWalletPassword}
                          disabled={forgetWalletLoading}
                        >
                          {forgetWalletLoading
                            ? "Processing..."
                            : "Forget Wallet Password"}
                        </button>

                        <button
                          className="btn btn-info ms-2"
                          onClick={() => openModal("resetWalletModal")}
                        >
                          Reset Wallet Password
                        </button>

                        <button
                          className="btn btn-primary ms-2"
                          onClick={getCardList}
                          disabled={cardLoading}
                        >
                          {cardLoading
                            ? "Loading..."
                            : "Card List"}
                        </button>

                        <button
                          className="btn btn-dark ms-2"
                          onClick={requestPhysicalCard}
                          disabled={physicalCardLoading}
                        >
                          {
                            physicalCardLoading
                              ? "Requesting..."
                              : "Request Physical Card"
                          }
                        </button>

                        <button
                          className="btn btn-info ms-2"
                          onClick={fetchCardPreference}
                          disabled={preferenceLoading}
                        >
                          {
                            preferenceLoading
                              ? "Loading..."
                              : "Card Preference"
                          }
                        </button>

                        <button
                          className="btn btn-primary ms-2"
                          onClick={() =>
                            openModal("merchantProfileModal")
                          }
                        >
                          Register Merchant Profile
                        </button>

                        


                      </div>

                    </div>
                  </div>
                )}

                {/* WALLET SECTION */}

                {selectedMerchant?.status === "ACTIVE" && (

                  <div className="card mb-4">
                    <div className="card-body">

                      <h5>Wallet Balance</h5>

                      <hr />

                      <div className="row">

                        {walletBalance.map((wallet, index) => (

                          <div className="col-md-3 mb-3" key={index}>

                            <div className="border rounded p-3">
                              <strong>{wallet.walletType}</strong>

                              <h4>
                                ₹ {wallet.balance}
                              </h4>
                            </div>

                          </div>
                        ))}

                      </div>

                    </div>
                  </div>
                )}

                {/* TRANSACTIONS */}

                {selectedMerchant?.status === "ACTIVE" && (

                  <div className="card">
                    <div className="card-body">

                      <div className="d-flex justify-content-between align-items-center">

                        <h5>Wallet Transactions</h5>

                        <button
                          className="btn btn-primary btn-sm"
                          onClick={getTransactions}
                        >
                          Refresh
                        </button>

                      </div>

                      <hr />

                      <div className="table-responsive">

                        <table className="table table-bordered">

                          <thead>
                            <tr>
                              <th>Txn ID</th>
                              <th>Amount</th>
                              <th>Type</th>
                              <th>Status</th>
                            </tr>
                          </thead>

                          <tbody>

                            {transactions.map((txn, index) => (
                              <tr key={index}>
                                <td>{txn.txnId}</td>
                                <td>{txn.amount}</td>
                                <td>{txn.type}</td>
                                <td>{txn.status}</td>
                              </tr>
                            ))}

                          </tbody>

                        </table>

                      </div>

                    </div>
                  </div>
                )}

                {/* MERCHANT LIST */}

                <div className="card mt-4">
                  <div className="card-body">

                    <h5>Merchant List</h5>

                    <hr />

                    <div className="table-responsive">

                      <table className="table table-bordered table-striped">

                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Merchant ID</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>

                          {merchantList.map((merchant, index) => (

                            <tr key={index}>

                              <td>{index + 1}</td>

                              <td>
                                <span className="badge bg-dark">
                                  {merchant.merchantId}
                                </span>
                              </td>

                              <td>{merchant.name}</td>

                              <td>{merchant.mobile}</td>

                              <td>
                                <span className="badge bg-primary">
                                  {merchant.status}
                                </span>
                              </td>

                              <td>

                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => handleSelectMerchant(merchant)}
                                >
                                  Select
                                </button>

                              </td>

                            </tr>
                          ))}

                        </tbody>

                      </table>

                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ===================================== */}
      {/* REGISTER MODAL */}
      {/* ===================================== */}

      <div
        className="modal fade"
        id="registerMerchantModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">
                Register Merchant
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body row">

              <div className="col-md-4 mb-3">
                <label>Name</label>
                <input
                  className="form-control"
                  value={registerForm.name}
                  onChange={(e) =>
                    setRegisterForm({
                      ...registerForm,
                      name: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-4 mb-3">
                <label>Email</label>
                <input
                  className="form-control"
                  value={registerForm.email}
                  onChange={(e) =>
                    setRegisterForm({
                      ...registerForm,
                      email: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-4 mb-3">
                <label>Mobile</label>
                <input
                  className="form-control"
                  value={registerForm.mobile}
                  onChange={(e) =>
                    setRegisterForm({
                      ...registerForm,
                      mobile: e.target.value,
                    })
                  }
                />
              </div>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                className="btn btn-primary"
                onClick={handleRegisterMerchant}
                disabled={loading}
              >
                {loading ? "Please Wait..." : "Register Merchant"}
              </button>

            </div>

          </div>
        </div>
      </div>

      {/* ===================================== */}
      {/* OTP MODAL */}
      {/* ===================================== */}

      <div
        className="modal fade"
        id="otpModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">
                Verify OTP
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body row">

              {/* OTP */}
              <div className="col-md-6 mb-3">
                <label className="form-label">OTP</label>

                <input
                  className="form-control"
                  value={otpForm.otp}
                  onChange={(e) =>
                    setOtpForm({
                      ...otpForm,
                      otp: e.target.value,
                    })
                  }
                />
              </div>

              {/* Marital Status */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Marital Status
                </label>

                <select
                  className="form-select"
                  value={otpForm.maritalStatus}
                  onChange={(e) =>
                    setOtpForm({
                      ...otpForm,
                      maritalStatus: e.target.value,
                    })
                  }
                >
                  <option value=""  disabled>
                    Select Status
                  </option>
                  {maritalStatuses.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>

              {/* Employment Industry */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Employment Industry
                </label>

                <select
                  className="form-select"
                  value={otpForm.employmentIndustry}
                  onChange={(e) =>
                    setOtpForm({
                      ...otpForm,
                      employmentIndustry: e.target.value,
                    })
                  }
                >
                  <option value=""  disabled>
                    Select Industry
                  </option>

                  {employmentIndustries.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>

              {/* Employment Type */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Employment Type
                </label>

                <select
                  className="form-select"
                  value={otpForm.employmentType}
                  onChange={(e) =>
                    setOtpForm({
                      ...otpForm,
                      employmentType: e.target.value,
                    })
                  }
                >
                  <option value=""  disabled>
                    Select Type
                  </option>
                  {employmentTypes.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>

              {/* Account Number */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Account Number
                </label>

                <input
                  className="form-control"
                  value={otpForm.accountno}
                  onChange={(e) =>
                    setOtpForm({
                      ...otpForm,
                      accountno: e.target.value,
                    })
                  }
                />
              </div>

              {/* Bank Name */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Bank Name
                </label>

                <input
                  className="form-control"
                  value={otpForm.bankName}
                  onChange={(e) =>
                    setOtpForm({
                      ...otpForm,
                      bankName: e.target.value,
                    })
                  }
                />
              </div>

              {/* Branch Name */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Branch Name
                </label>

                <input
                  className="form-control"
                  value={otpForm.branchName}
                  onChange={(e) =>
                    setOtpForm({
                      ...otpForm,
                      branchName: e.target.value,
                    })
                  }
                />
              </div>

              {/* IFSC */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  IFSC Code
                </label>

                <input
                  className="form-control"
                  value={otpForm.ifscCode}
                  onChange={(e) =>
                    setOtpForm({
                      ...otpForm,
                      ifscCode: e.target.value.toUpperCase(),
                    })
                  }
                />
              </div>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                className="btn btn-success"
                onClick={handleVerifyOtp}
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>

            </div>

          </div>
        </div>
      </div>

      {/* ===================================== */}
      {/* PAN OCR MODAL */}
      {/* ===================================== */}

      <div
        className="modal fade"
        id="panModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">
                PAN OCR
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body">

              <input
                type="file"
                className="form-control"
                onChange={handlePanUpload}
              />

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-primary"
                onClick={handlePanOcr}
              >
                Submit PAN OCR
              </button>

            </div>

          </div>
        </div>
      </div>

      {/* ===================================== */}
      {/* VCIP MODAL */}
      {/* ===================================== */}

      <div
        className="modal fade"
        id="vcipModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">
                VCIP Verification
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body">

              <div className="d-flex gap-2 mb-3">

                <button
                  className="btn btn-primary"
                  onClick={handleStartVcip}
                >
                  Start VCIP
                </button>

                <button
                  className="btn btn-success"
                  onClick={handleCheckVcip}
                >
                  Check Status
                </button>

              </div>

              {vcipData && (

                <>

                  <a
                    href={vcipData.vciplink}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-dark mb-3"
                  >
                    Open VCIP Link
                  </a>

                  <div>
                    <img
                      src={`data:image/png;base64,${vcipData.qrimage}`}
                      alt="qr"
                      style={{ width: "250px" }}
                    />
                  </div>

                </>
              )}

            </div>

          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="walletDebitModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">
                Wallet Debit
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body">

              <div className="mb-3">
                <label className="form-label">
                  Amount
                </label>

                <input
                  type="number"
                  className="form-control"
                  value={walletDebitForm.amount}
                  onChange={(e) =>
                    setWalletDebitForm({
                      ...walletDebitForm,
                      amount: e.target.value,
                    })
                  }
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Description
                </label>

                <textarea
                  className="form-control"
                  rows="3"
                  value={walletDebitForm.description}
                  onChange={(e) =>
                    setWalletDebitForm({
                      ...walletDebitForm,
                      description: e.target.value,
                    })
                  }
                />
              </div>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                className="btn btn-danger"
                onClick={handleWalletDebit}
                disabled={walletDebitLoading}
              >
                {walletDebitLoading
                  ? "Processing..."
                  : "Debit Wallet"}
              </button>

            </div>

          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="walletTopupModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">
                Wallet Topup
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body">

              <div className="mb-3">
                <label className="form-label">
                  Amount
                </label>

                <input
                  type="number"
                  className="form-control"
                  value={walletTopupForm.amount}
                  onChange={(e) =>
                    setWalletTopupForm({
                      amount: e.target.value,
                    })
                  }
                />
              </div>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                className="btn btn-success"
                onClick={handleWalletTopup}
                disabled={walletTopupLoading}
              >
                {walletTopupLoading
                  ? "Processing..."
                  : "Topup Wallet"}
              </button>

            </div>

          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="walletPasswordModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">

              <h5 className="modal-title">
                Validate Wallet Password
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />

            </div>

            <div className="modal-body">

              <div className="mb-3">

                <label className="form-label">
                  Wallet Password
                </label>

                <input
                  type="password"
                  className="form-control"
                  value={walletPasswordForm.credential}
                  onChange={(e) =>
                    setWalletPasswordForm({
                      credential: e.target.value,
                    })
                  }
                />

              </div>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                className="btn btn-dark"
                onClick={handleValidateWalletPassword}
                disabled={walletPasswordLoading}
              >
                {walletPasswordLoading
                  ? "Validating..."
                  : "Validate"}
              </button>

            </div>

          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="resetWalletModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">

              <h5 className="modal-title">
                Reset Wallet Password
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />

            </div>

            <div className="modal-body">

              <div className="mb-3">

                <label className="form-label">
                  OTP Code
                </label>

                <input
                  className="form-control"
                  value={resetWalletForm.otpCode}
                  onChange={(e) =>
                    setResetWalletForm({
                      ...resetWalletForm,
                      otpCode: e.target.value,
                    })
                  }
                />

              </div>

              <div className="mb-3">

                <label className="form-label">
                  New Wallet Password
                </label>

                <input
                  type="password"
                  className="form-control"
                  value={resetWalletForm.credential}
                  onChange={(e) =>
                    setResetWalletForm({
                      ...resetWalletForm,
                      credential: e.target.value,
                    })
                  }
                />

              </div>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                className="btn btn-info"
                onClick={handleResetWalletPassword}
                disabled={resetWalletLoading}
              >
                {resetWalletLoading
                  ? "Processing..."
                  : "Reset Password"}
              </button>

            </div>

          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="cardListModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">

            <div className="modal-header">

              <h5 className="modal-title">
                Card List
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />

            </div>

            <div className="modal-body table-responsive">

              <table className="table table-bordered">

                <thead>

                  <tr>
                    <th>Masked Card</th>
                    <th>Status</th>
                    <th>Card Type</th>
                    <th>Expiry</th>
                    <th>Kit Number</th>
                    <th>Network</th>
                    <th>Action</th>
                  </tr>

                </thead>

                <tbody>

                  {cardList?.cardList?.length > 0 ? (

                    cardList.cardList.map((card, index) => (

                      <tr key={index}>

                        <td>{card || "-"}</td>

                        <td>
                          {cardList.cardStatusList?.[index] || "-"}
                        </td>

                        <td>
                          {cardList.cardTypeList?.[index] || "-"}
                        </td>

                        <td>
                          {cardList.expiryDateList?.[index] || "-"}
                        </td>

                        <td>
                          {cardList.kitList?.[index] || "-"}
                        </td>

                        <td>
                          {cardList.networkTypeList?.[index] || "-"}
                        </td>

                        <td>
                          <button
                            className="btn btn-sm btn-dark"
                            onClick={() =>
                              getCardDetails(
                                cardList.kitList?.[index]
                              )
                            }
                          >
                            View Card
                          </button>
                          <button
                            className="btn btn-sm btn-warning ms-2"
                            onClick={() => {

                              setCardActionForm({
                                kitNo: cardList.kitList?.[index],
                                flag: "L",
                                reason: "",
                              });

                              openModal("cardActionModal");
                            }}
                          >
                            Card Action
                          </button>
                        </td>

                      </tr>
                    ))

                  ) : (

                    <tr>
                      <td
                        colSpan="6"
                        className="text-center"
                      >
                        No Cards Found
                      </td>
                    </tr>

                  )}

                </tbody>

              </table>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

            </div>

          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="cardActionModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">

              <h5 className="modal-title">
                Card Action
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />

            </div>

            <div className="modal-body">

              <div className="mb-3">

                <label className="form-label">
                  Kit Number
                </label>

                <input
                  className="form-control"
                  value={cardActionForm.kitNo}
                  disabled
                />

              </div>

              <div className="mb-3">

                <label className="form-label">
                  Action
                </label>

                <select
                  className="form-select"
                  value={cardActionForm.flag}
                  onChange={(e) =>
                    setCardActionForm({
                      ...cardActionForm,
                      flag: e.target.value,
                    })
                  }
                >
                  {cardActionFlags.map((item) => (
                    <option
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </option>
                  ))}
                </select>

              </div>

              <div className="mb-3">

                <label className="form-label">
                  Reason
                </label>

                <textarea
                  className="form-control"
                  rows="3"
                  value={cardActionForm.reason}
                  onChange={(e) =>
                    setCardActionForm({
                      ...cardActionForm,
                      reason: e.target.value,
                    })
                  }
                />

              </div>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                className="btn btn-primary"
                onClick={handleCardAction}
                disabled={cardActionLoading}
              >
                {cardActionLoading
                  ? "Processing..."
                  : "Submit"}
              </button>

            </div>

          </div>
        </div>
      </div>


      <div
        className="modal fade"
        id="cardPreferenceModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">

            <div className="modal-header">

              <h5 className="modal-title">
                Card Preference
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />

            </div>

            <div className="modal-body">

              <table className="table table-bordered">

                <tbody>

                  <tr>
                    <th>ATM</th>
                    <td>
                      <select
                        className="form-select"
                        value={cardPreference?.atm ? "true" : "false"}
                        onChange={(e) =>
                          setCardPreference({
                            ...cardPreference,
                            atm: e.target.value === "true",
                          })
                        }
                      >
                        <option value="true">Enabled</option>
                        <option value="false">Disabled</option>
                      </select>
                    </td>
                    
                  </tr>

                  <tr>
                    <th>POS</th>
                    <td>
                      <select
                        className="form-select"
                        value={cardPreference?.pos ? "true" : "false"}
                        onChange={(e) =>
                          setCardPreference({
                            ...cardPreference,
                            pos: e.target.value === "true",
                          })
                        }
                      >
                        <option value="true">Enabled</option>
                        <option value="false">Disabled</option>
                      </select>
                    </td>
                  </tr>

                  <tr>
                    <th>ECOM</th>
                    <td>
                      <select
                        className="form-select"
                        value={cardPreference?.ecom ? "true" : "false"}
                        onChange={(e) =>
                          setCardPreference({
                            ...cardPreference,
                            ecom: e.target.value === "true",
                          })
                        }
                      >
                        <option value="true">Enabled</option>
                        <option value="false">Disabled</option>
                      </select>
                    </td>
                  </tr>

                  <tr>
                    <th>International</th>
                    <td>
                      <select
                        className="form-select"
                        value={cardPreference?.international ? "true" : "false"}
                        onChange={(e) =>
                          setCardPreference({
                            ...cardPreference,
                            international: e.target.value === "true",
                          })
                        }
                      >
                        <option value="true">Enabled</option>
                        <option value="false">Disabled</option>
                      </select>
                    </td>
                  </tr>

                  <tr>
                    <th>Contactless</th>
                    <td>
                      <select
                        className="form-select"
                        value={cardPreference?.contactless ? "true" : "false"}
                        onChange={(e) =>
                          setCardPreference({
                            ...cardPreference,
                            contactless: e.target.value === "true",
                          })
                        }
                      >
                        <option value="true">Enabled</option>
                        <option value="false">Disabled</option>
                      </select>        
                    </td>
                  </tr>

                  <tr>
                    <th>DCC</th>
                    <td>
                      <select
                        className="form-select"
                        value={cardPreference?.dcc ? "true" : "false"}
                        onChange={(e) =>
                          setCardPreference({
                            ...cardPreference,
                            dcc: e.target.value === "true",
                          })
                        }
                      >
                        <option value="true">Enabled</option>
                        <option value="false">Disabled</option>
                      </select>
                    </td>
                  </tr>

                </tbody>

              </table>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                className="btn btn-success"
                onClick={setCardPreferenceApi}
                disabled={savePreferenceLoading}
              >
                {
                  savePreferenceLoading
                    ? "Saving..."
                    : "Save Preference"
                }
              </button>

            </div>

          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="merchantProfileModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">

              <h5 className="modal-title">
                Register Merchant Profile
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />

            </div>

            <div className="modal-body row">

              <div className="col-md-6 mb-3">
                <label>Legal Name</label>

                <input
                  className="form-control"
                  value={merchantProfileForm.legalName}
                  onChange={(e) =>
                    setMerchantProfileForm({
                      ...merchantProfileForm,
                      legalName: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6 mb-3">
                <label>MCC Code</label>

                <input
                  className="form-control"
                  value={merchantProfileForm.mccCode}
                  onChange={(e) =>
                    setMerchantProfileForm({
                      ...merchantProfileForm,
                      mccCode: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6 mb-3">
                <label>Merchant Type</label>

                <input
                  className="form-control"
                  value={merchantProfileForm.merchantType}
                  onChange={(e) =>
                    setMerchantProfileForm({
                      ...merchantProfileForm,
                      merchantType: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6 mb-3">
                <label>Merchant Genre</label>

                <input
                  className="form-control"
                  value={merchantProfileForm.merchantGenre}
                  onChange={(e) =>
                    setMerchantProfileForm({
                      ...merchantProfileForm,
                      merchantGenre: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6 mb-3">
                <label>Brand Name</label>

                <input
                  className="form-control"
                  value={merchantProfileForm.brandName}
                  onChange={(e) =>
                    setMerchantProfileForm({
                      ...merchantProfileForm,
                      brandName: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6 mb-3">
                <label>Ownership Type</label>

                <input
                  className="form-control"
                  value={merchantProfileForm.ownershipType}
                  onChange={(e) =>
                    setMerchantProfileForm({
                      ...merchantProfileForm,
                      ownershipType: e.target.value,
                    })
                  }
                />
              </div>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                className="btn btn-success"
                onClick={registerMerchantProfile}
                disabled={merchantProfileLoading}
              >
                {
                  merchantProfileLoading
                    ? "Submitting..."
                    : "Submit"
                }
              </button>

            </div>

          </div>
        </div>
      </div>          
     
    </>
  );
}